module.exports = __webpack_public_path__ + "img/corona-generator.jpg_w545.5fde0eed.jpg";